"use strict";

exports.__esModule = true;
var _DaysOfTheWeekSelector = require("./DaysOfTheWeekSelector");
Object.keys(_DaysOfTheWeekSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DaysOfTheWeekSelector[key]) return;
  exports[key] = _DaysOfTheWeekSelector[key];
});